import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledCategoryList = styled.section`
    background: ${theme.colors.hover};
    margin-top: -1px;
	padding-top: 120px;

    ${devices.sm} {
        padding-bottom: 95px;

		.container-fluid{
			.row{
                gap: 15px;
                margin: 0;
                align-items: center;
                justify-content: center;
			}
		}
        .col-md-3{
			max-width: calc(50% - 15px);
			width: calc(50% - 15px);
			&:nth-of-type(1){
				order: 1;
			}
			&:nth-of-type(2){
				order: 2;
			}
			&:nth-of-type(3){
				order: 4;
			}
			&:nth-of-type(4){
				order: 3;
			}
		}
    }

`;